let pendingText = null;
export function getPendingSharedText() {
    return pendingText;
}
export function setPendingSharedText(text) {
    pendingText = text;
}
